import {combineReducers} from 'redux';

import {IHorseFiltersState, Actions, getAllGenePoolsActionTypes} from '../types';
import {makeCommunicationReducerFromEnum} from 'Common/store/utils/communication';

export const communicationGenePoolsReducer = combineReducers<IHorseFiltersState['communications'], Actions>({
  genePoolsLoading: makeCommunicationReducerFromEnum(getAllGenePoolsActionTypes)
});
